import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ConnectWithResolve from "./sections/ConnectWithResolve";
import OurReach from "./sections/OurReach";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ConnectWithResolve />
      <OurReach />
      <Footer />
    </div>;
}